import { QuizzDetail as QuizzDetailComponent } from './QuizzDetail.component';
import { connector } from './QuizzDetail.connector';

export const QuizzDetail = connector(QuizzDetailComponent);
